export const RewardIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>
          {
            '.cls-1{fill:#ffd578;}.cls-1,.cls-2,.cls-3{stroke:#54596e;}.cls-1,.cls-2,.cls-3,.cls-4{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-2{fill:#ff80c3;}.cls-3{fill:#a1b7ff;}.cls-4{fill:none;stroke:#a1b7ff;}'
          }
        </style>
      </defs>
      <title>{'gift'}</title>
      <g id="gift">
        <path
          className="cls-1"
          d="M11,29H55a0,0,0,0,1,0,0V57.54A3.46,3.46,0,0,1,51.54,61H14.46A3.46,3.46,0,0,1,11,57.54V29A0,0,0,0,1,11,29Z"
        />
        <rect className="cls-2" x={29} y={29} width={8} height={32} />
        <path
          className="cls-3"
          d="M13.49,20h39A6.49,6.49,0,0,1,59,26.49V29a0,0,0,0,1,0,0H7a0,0,0,0,1,0,0V26.49A6.49,6.49,0,0,1,13.49,20Z"
        />
        <rect className="cls-2" x={27} y={20} width={12} height={9} />
        <path
          className="cls-2"
          d="M33,12h0a3,3,0,0,1,3,3v5a0,0,0,0,1,0,0H30a0,0,0,0,1,0,0V15A3,3,0,0,1,33,12Z"
        />
        <path
          className="cls-2"
          d="M36,16h7a4,4,0,0,1,4,4v0a0,0,0,0,1,0,0H36a0,0,0,0,1,0,0V16a0,0,0,0,1,0,0Z"
        />
        <polygon className="cls-2" points="44.02 16 40.02 12 36.02 16 44.02 16" />
        <path
          className="cls-2"
          d="M19,16H30a0,0,0,0,1,0,0v0a4,4,0,0,1-4,4H19a0,0,0,0,1,0,0V16A0,0,0,0,1,19,16Z"
          transform="translate(49 36) rotate(180)"
        />
        <polygon className="cls-2" points="21.98 16 25.98 12 29.98 16 21.98 16" />
        <line className="cls-4" x1={13} y1={8} x2={16} y2={11} />
        <line className="cls-4" x1={16} y1={8} x2={13} y2={11} />
        <line className="cls-4" x1={52} y1={12} x2={55} y2={15} />
        <line className="cls-4" x1={55} y1={12} x2={52} y2={15} />
        <line className="cls-4" x1={33} y1={2} x2={36} y2={5} />
        <line className="cls-4" x1={36} y1={2} x2={33} y2={5} />
      </g>
    </svg>
  )
}
